import(/* webpackMode: "eager" */ "/home/jenkins/workspace/prod/deploy-frontend/src/app/[lang]/(editor)/layout.tsx");
